exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".AlbumList-local__list--2hTMr {\n  position: relative;\n  margin: 0 -0.5rem; }\n  .AlbumList-local__list--2hTMr > li {\n    padding: 0 0.5rem;\n    margin-bottom: 1rem; }\n    .AlbumList-local__list--2hTMr > li > div > div {\n      top: 50px;\n      bottom: 20px;\n      left: 20px;\n      right: 20px; }\n  .AlbumList-local__list--2hTMr .AlbumList-local__media--nm6Rc {\n    height: 8.75rem;\n    width: 100%;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    -webkit-box-shadow: 0px 4px 4px rgba(41, 57, 77, 0.3);\n            box-shadow: 0px 4px 4px rgba(41, 57, 77, 0.3);\n    border-radius: 5px; }\n    .AlbumList-local__list--2hTMr .AlbumList-local__media--nm6Rc.AlbumList-local__forAlbum--hY2cz {\n      height: 2.875rem;\n      border-radius: 2px; }\n", ""]);

// exports
exports.locals = {
	"list": "AlbumList-local__list--2hTMr",
	"media": "AlbumList-local__media--nm6Rc",
	"forAlbum": "AlbumList-local__forAlbum--hY2cz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/media/media/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src"]}!./src/components/Common/AlbumList/AlbumList.local.scss
// module id = 468
// module chunks = 0